import {
  globalSearchParamsSchema,
  SEARCH_PARAM_ORG_ID,
  SEARCH_PARAM_SITE_ID,
} from 'routes/(global_search_params)/-searchParams'
import { z } from 'zod'

export const walkthroughSearchParams = z.object({
  ...globalSearchParamsSchema.shape,
})

export type WalkthroughSearch = z.infer<typeof walkthroughSearchParams>

export const createWalkthroughSearch = ({
  orgId,
  siteId,
}: WalkthroughSearch) => ({
  [SEARCH_PARAM_ORG_ID]: orgId,
  [SEARCH_PARAM_SITE_ID]: siteId,
})

export function createWalkthroughUrl(searchParams: WalkthroughSearch): string {
  const search = new URLSearchParams()

  for (const [key, value] of Object.entries(
    createWalkthroughSearch(searchParams)
  )) {
    if (value !== undefined) {
      search.set(key, value)
    }
  }

  const query = search.toString()

  return query ? `/walkthrough?${query}` : '/walkthrough'
}
